(function($) {
    'use strict';

    // Dropdown interaction for the mobile main-menu overlay
    $('.topbar__mobile-overlay .menu-item-has-children .sub-menu:not(:first)').hide();
    $('.topbar__mobile-overlay .menu-item-has-children:first').addClass('menu-item-dropdown-open');

    $('.topbar__mobile-overlay .menu-item-has-children').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('menu-item-dropdown-open');
        $(this).find('.sub-menu').slideToggle(200);
    });

    $('.topbar__mobile-overlay .menu-item-has-children .sub-menu a').on('click', function (e) {
        e.stopPropagation();
    });

    // set testimonial overview button selected
    if ( $('body.single-testimonial').length && $('.menu-item-testimonial-overview').length) {
        $('.menu-item-testimonial-overview').addClass('current-menu-item');
    }

    // set article overview button selected
    if ( $('body.single-public_post').length && $('.menu-item-public_post-overview').length) {
        $('.menu-item-public_post-overview').addClass('current-menu-item');
    }

})(jQuery);